import { Button } from "../../components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({ page, pages, total, limit, onChange }) {
  const from = total === 0 ? 0 : (page - 1) * limit + 1;
  const to = Math.min(page * limit, total);

  const go = (p) => {
    if (p < 1 || p > pages) return;
    onChange(p);
  };

  // Janela de páginas
  const windowSize = 5;
  let start = Math.max(1, page - Math.floor(windowSize / 2));
  let end = Math.min(pages, start + windowSize - 1);
  start = Math.max(1, end - windowSize + 1);
  const numbers = [];
  for (let i = start; i <= end; i++) numbers.push(i);

  return (
    <div className="flex items-center justify-between flex-wrap gap-3 px-5 py-3 border-t border-slate-200 bg-slate-50/60">
      <p className="text-xs text-slate-500" data-testid="pagination-info">
        Mostrando <span className="font-medium text-slate-700">{from}</span>–
        <span className="font-medium text-slate-700">{to}</span> de{" "}
        <span className="font-medium text-slate-700">{total}</span> registros
      </p>
      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="sm"
          className="h-8 px-2"
          onClick={() => go(page - 1)}
          disabled={page <= 1}
          data-testid="pagination-prev"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        {start > 1 && (
          <>
            <Button variant="ghost" size="sm" className="h-8 w-8 p-0 text-xs" onClick={() => go(1)}>1</Button>
            {start > 2 && <span className="px-1 text-slate-400 text-xs">…</span>}
          </>
        )}
        {numbers.map((n) => (
          <Button
            key={n}
            variant={n === page ? "default" : "ghost"}
            size="sm"
            className={`h-8 w-8 p-0 text-xs ${n === page ? "bg-slate-900 text-white hover:bg-slate-800" : ""}`}
            onClick={() => go(n)}
            data-testid={`pagination-page-${n}`}
          >
            {n}
          </Button>
        ))}
        {end < pages && (
          <>
            {end < pages - 1 && <span className="px-1 text-slate-400 text-xs">…</span>}
            <Button variant="ghost" size="sm" className="h-8 w-8 p-0 text-xs" onClick={() => go(pages)}>
              {pages}
            </Button>
          </>
        )}
        <Button
          variant="outline"
          size="sm"
          className="h-8 px-2"
          onClick={() => go(page + 1)}
          disabled={page >= pages}
          data-testid="pagination-next"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
